import { ListMagnifyingGlassIcon } from "@phosphor-icons/react";
import { Button } from "./Button";

/** "Find Similar" — hands the rendered design to Google Lens in a new tab. */
export function GoogleLensButton({ imageUrl }: { imageUrl: string }) {
  const handleClick = () => {
    const lensUrl = `https://lens.google.com/uploadbyurl?url=${encodeURIComponent(imageUrl)}`;
    window.open(lensUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Button variant="toolbar" onClick={handleClick} disabled={!imageUrl}>
      <span>Find Similar</span>
      <ListMagnifyingGlassIcon size={16} aria-hidden />
    </Button>
  );
}
